module.exports = __webpack_public_path__ + "static/img/concierce_visual.96d9ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/concierce_visual.png
// module id = xsj+
// module chunks = 0